import React from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

// Components
import ContentCardHeader from "src/components/ContentCardHeader";
import CaseMediaTipsButton from "src/components/CaseMediaTips/CaseMediaTipsButton";
import AddMedicalRecords from "src/components/AddMedicalRecords";
import Text from "src/components/Text";

// Config
import styles from "../../config/styles";

const useStyles = makeStyles(theme => ({
  root: {
    border: styles.values.border
  },
  buttonWrapper: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1)
  }
}));

const MedicalRecordsPanelLayout = ({ children }) => {
  const { caseId } = useParams();
  const classes = useStyles();

  return (
    <Paper elevation={0} className={classes.root}>
      <ContentCardHeader>
        <Text text="medicalRecordsPage.title" type="heading2" />
        <div className={classes.buttonWrapper}>
          <CaseMediaTipsButton page="medicalRecordsPage" />
          <AddMedicalRecords caseId={caseId} />
        </div>
      </ContentCardHeader>
      {children}
    </Paper>
  );
};

MedicalRecordsPanelLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default MedicalRecordsPanelLayout;
